import { render, staticRenderFns } from "./Shortened.vue?vue&type=template&id=6fe4f05b&"
import script from "./Shortened.vue?vue&type=script&lang=js&"
export * from "./Shortened.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports